import { Tabs, styled } from '@mui/material';

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  minHeight: 'auto',

  '.Mui-selected': {
    background: 'transparent !important',
  },

  '.MuiTab-root': {
    minHeight: 'auto',
    minWidth: 0,
    background: 'transparent !important',
    transition: 'all 0.3s',

    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}));
